import React from 'react'

const FacebookIconNew = (props) => (
  <svg
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={48} height={48} rx={24} fill="#3C5997" />
    <path
      d="M25.9883 24.9024H30.4549L31.1562 20.9327H25.9874V18.7631C25.9874 17.1141 26.6033 15.6518 28.3665 15.6518H31.1998V12.1876C30.702 12.1287 29.6492 12 27.6598 12C23.5056 12 21.0702 13.9193 21.0702 18.2919V20.9327H16.7998V24.9024H21.0702V35.8132C21.9159 35.9245 22.7726 36 23.6519 36C24.4467 36 25.2225 35.9364 25.9883 35.8458V24.9024Z"
      fill="white"
    />
  </svg>
)
export default FacebookIconNew
